import { memo } from 'react';

import styles from '../FileIconChat.styles.m.css';

export const FileIconComplete = memo(() => {
  return (
    <>
      <circle
        className={styles.primaryColor}
        cx="39"
        cy="39"
        r="9"
      />
      <path
        className={styles.secondaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M41.177 36.2831C41.6063 35.8941 42.2848 35.9074 42.6969 36.314C43.1137 36.7252 43.0986 37.3811 42.6643 37.7746L39.1477 41.7146C38.7278 42.0951 38.0686 42.0951 37.6487 41.7146L35.3357 39.6189C34.9014 39.2254 34.8863 38.5695 35.3031 38.1582C35.7152 37.7517 36.3937 37.7384 36.823 38.1274L38.3982 39.5547L41.177 36.2831Z"
      />
      <path
        className={styles.primaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.12 29.8855C43.6921 28.0247 44 26.0483 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C26.0483 44 28.0247 43.6921 29.8855 43.12C29.3167 41.8637 29 40.4688 29 39C29 33.4772 33.4772 29 39 29C40.4688 29 41.8637 29.3167 43.12 29.8855Z"
      />
      <path
        className={styles.secondaryColor}
        d="M31.5389 19.94C30.8766 18.7823 29.6443 17.6151 28.81 16.9C28.3341 16.4958 27.1146 15.4925 25.88 14.8429V19.63C25.88 19.8 26.02 19.94 26.19 19.94L31.5389 19.94Z"
      />
      <path
        className={styles.secondaryColor}
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.88 14.25H23.21C20.95 14.25 19.3 14.25 18.2 14.41C17.21 14.55 16.42 15.48 16.3 16.66C15.9 20.64 15.9 27.1 16.3 31.07C16.4 32.04 17.04 32.88 17.97 33.26C19.17 33.75 21.41 33.75 24 33.75C27.07 33.75 29.01 33.71 30.06 33.25C30.99 32.84 31.6 32.02 31.7 31.07C31.9477 28.6203 31.9934 24.2177 31.9993 21.94L26.19 21.94C24.91 21.94 23.88 20.9 23.88 19.63V14.25Z"
      />
    </>
  );
});
